/* istanbul ignore file */

export var getFooterLinks = function getFooterLinks() {
  return [{
    title: 'Popular departments',
    links: [{
      text: 'Baby & Kids',
      url: '/department/baby-child'
    }, {
      text: 'Experiences',
      url: '/department/experiences'
    }, {
      text: 'Food & Drink',
      url: '/department/food-drink'
    }, {
      text: 'Gifts',
      url: '/department/gifts'
    }, {
      text: 'Home',
      url: '/department/home'
    }, {
      text: 'Jewellery',
      url: '/department/jewellery'
    }, {
      text: 'Personalised',
      url: '/department/personalised'
    }, {
      text: 'Weddings',
      url: '/department/weddings'
    }]
  }, {
    title: 'Shopping with us',
    links: [{
      text: 'Delivery information',
      url: 'https://info.notonthehighstreet.com/hc/en-us/articles/360007444693-Delivery-',
      target: '_blank'
    }, {
      text: 'Returns and cancellations',
      url: 'https://info.notonthehighstreet.com/hc/en-us/articles/206411168-What-is-your-returns-policy-',
      target: '_blank'
    }, {
      text: 'Gift cards',
      url: '/gift-cards'
    }, {
      text: 'Corporate gifts',
      url: '/pages/corporate-gifts'
    }, {
      text: 'Discount and promo codes',
      url: '/about/discounts-promo-codes'
    }, {
      text: 'NOTHS Partnerships',
      url: '/about/noths-partnerships'
    }, {
      text: 'Customer reviews',
      url: '/reviews'
    }, {
      text: 'Price promise',
      url: '/about/not-on-the-high-street-price-promise'
    }]
  }, {
    title: 'Help',
    links: [{
      text: 'Frequently asked questions',
      url: 'https://info.notonthehighstreet.com/hc/en-us',
      target: '_blank'
    }, {
      text: 'Where’s my order?',
      url: 'https://info.notonthehighstreet.com/hc/en-us/articles/115000990594-My-order-is-overdue-can-I-track-it-',
      target: '_blank'
    }, {
      text: 'My Account',
      url: '/user',
      rel: 'nofollow'
    }, {
      text: 'Contact us',
      url: 'https://info.notonthehighstreet.com/hc/en-us/articles/207113987-How-do-I-contact-you-',
      target: '_blank'
    }, {
      text: 'Contact Seller',
      url: 'https://info.notonthehighstreet.com/hc/en-us/articles/14040370112148-How-do-I-contact-the-Seller-',
      target: '_blank'
    }]
  }, {
    title: 'Useful stuff',
    links: [{
      text: 'Who we are',
      url: '/pages/our-story'
    }, {
      text: 'Careers',
      url: 'https://notonthehighstreet.pinpointhq.com/',
      rel: 'nofollow'
    }, {
      text: 'The Inspiration Hub',
      url: '/campaign/inspiration'
    }, {
      text: 'Press centre',
      url: '/pages/press-centre'
    }, {
      text: 'Collab with us',
      url: 'https://notonthehighstreet.grin.live/',
      rel: 'nofollow'
    }]
  }, {
    title: 'For sellers',
    links: [{
      text: 'Why sell with us?',
      url: '/pages/why-sell-with-us'
    }, {
      text: 'Seller FAQs',
      url: '/join/faqs'
    }, {
      text: 'Apply to sell with us',
      url: '/join/signup'
    }, {
      text: 'Seller terms and policies',
      url: '/about/seller-terms-and-policies',
      rel: 'nofollow'
    }, {
      text: 'Seller privacy and cookies',
      url: '/about/seller-privacy-and-cookies',
      rel: 'nofollow'
    }, {
      text: 'Become an affiliate',
      url: '/join/affiliates'
    }]
  }];
};